import React from 'react'
import { ErrorBoundary, FallbackProps } from 'react-error-boundary'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'
import { Button } from '@pandiafi/design-system'

import { resolveResidentAppErrorMessage } from '../../utils/resolveResidentAppErrorMessage'

import { Error as ErrorView } from 'components'

export const AppProviders = () => {
  const { t } = useTranslation(['errors', 'common'])

  const fallbackRender = ({ error }: FallbackProps) => {
    const { message, illustration, reloadButtonText } =
      resolveResidentAppErrorMessage(error as Error, t)

    return (
      <ErrorView
        message={message}
        illustration={illustration}
        action={
          reloadButtonText ? (
            <Button onClick={() => window.location.reload()}>
              {reloadButtonText}
            </Button>
          ) : undefined
        }
      />
    )
  }

  return (
    <ErrorBoundary fallbackRender={fallbackRender}>
      <Outlet />
    </ErrorBoundary>
  )
}
